export default __webpack_public_path__ + "static/media/clock.32e51af1.svg";